import styled from 'styled-components'

export default styled.div`
  font-size: 15px;
  padding: 10px;
  background: ${props => props.embedded ? 'transparent' : '#dee0eb'};
  border-radius: 3px;
  position: relative;
  margin-bottom: 10px;
  overflow: hidden;
`
